import React from 'react';

const CurtainSvg = (props) => (
    <svg viewBox="0 0 24 24" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M20 21V2H4v19H2v1h20v-1h-2zM5 7.7c.3.2.6.3 1 .3.6 0 1.1-.3 1.5-.7.3.4.8.7 1.4.7-.1 3.1-1.5 6.1-3.8 8.2V7.7zM19 21H5v-3.5c3-2.3 4.8-5.9 4.9-9.7.2-.1.5-.3.6-.5.4.4.9.7 1.5.7s1.1-.3 1.5-.7c.2.2.5.4.8.6.1 3.7 1.8 7.2 4.7 9.5V21zm0-4.9c-2.3-2.1-3.6-5-3.7-8.1.5-.1.9-.3 1.2-.7.4.4.9.7 1.5.7.4 0 .7-.1 1-.3v8.4zm0-10c0 .5-.5.9-1 .9s-1-.4-1-1h-1c0 .5-.4 1-1 1-.5 0-1-.4-1-1h-1c0 .5-.4 1-1 1-.5 0-1-.4-1-1h-1c0 .5-.4 1-1 1-.5 0-1-.4-1-1H7c0 .5-.4 1-1 1-.5 0-.9-.4-1-.8V3h14v3.1z"
        />
    </svg>
);

CurtainSvg.displayName = 'CurtainSvg';
export default CurtainSvg;
